/**
 * Styles for MenuMakerTabsNavigation component
 * @module components/MenuMakerTabsNavigation/styles
 */
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

/**
 * Styles hook for MenuMakerTabsNavigation
 * @returns Style classes
 */
// @ts-ignore
const useStyles = makeStyles<Theme>(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    zIndex: 1300,
  },
}));

export default useStyles;
